import React, { useEffect } from "react";
import {
  Map,
  APIProvider,
  useMap,
  InfoWindow,
} from "@vis.gl/react-google-maps";
import polyline from "polyline";
import { useTranslation } from "react-i18next";
import Loader from "./Loader";

interface GoogleMapProps {
  showMarkers?: boolean;
  showDirections?: boolean;
  showTerritories?: boolean;
  markersData?: {
    location: { lat: number; lng: number };
    label: string;
    status: string;
    emp_id: string;
  }[];
  directionsData?: any;
  territoriesData?: any;
  setSelectedMarker?: any;
  selectedMarker?: any;
  actualData?: any;
  startPoint?: any;
  selectedData?: any;
  plannedData?: any;
  selectedRoute?: any;
  handleRouteChange?: any;
  handleMarkerClick?: any;
  markarData?: any;
  showNotificationInfo?: any;
  customerLoaction?: any;
  storeLoaction?: any;
  handleCloseInfoWindow?: any;
  employeeSchedule?: any;
  routeForSelectedCustomer?: any;
  vehicleLocation?: any;
  locationPoint?: any;
  actualDataLoader?: any;
}

const GoogleMap: React.FC<GoogleMapProps> = ({
  actualDataLoader,
  showMarkers,
  showDirections,
  showTerritories,
  markersData,
  directionsData,
  territoriesData,
  setSelectedMarker,
  selectedMarker,
  plannedData,
  actualData,
  selectedData,
  selectedRoute,
  handleRouteChange,
  handleMarkerClick,
  markarData,
  showNotificationInfo,
  customerLoaction,
  storeLoaction,
  handleCloseInfoWindow,
  employeeSchedule,
  routeForSelectedCustomer,
  vehicleLocation,
  locationPoint,
  startPoint
}) => {
  const saudiCenter = { lat: 24.774265, lng: 46.738586 };
  const saudiBounds = {
    north: 33.0,
    south: 16.0,
    east: 60.0,
    west: 34.0,
  };

  const getFillColor = (status: string) => {
    switch (status) {
      case "idle":
        return "#FF4D68";
      case "at_location":
        return "#00C48C";
      case "enroute":
        return "purple";
      default:
        return "black";
    }
  };

  const { t } = useTranslation();

  function getRotatedSvg(bearing: any) {
    const svg = `<svg width="38" height="45" viewBox="0 0 38 45"  fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(${bearing}deg)" xmlns:xlink="http://www.w3.org/1999/xlink">
<g clip-path="url(#clip0_25255_47460)">
<path d="M4.58847 13.7597C4.13471 13.2916 3.33992 11.4612 3.33992 11.4612C2.32638 9.9005 4.42801 7.52884 5.84437 6.60905L9.4945 4.23863C10.9089 3.3201 13.9348 2.36744 14.9458 3.92426C14.9458 3.92426 16.2908 5.39735 16.5377 5.99973C16.7847 6.6021 18.5308 9.53434 18.5308 9.53434L7.00294 17.0206C7.00294 17.0206 5.04476 14.2317 4.58847 13.7597Z" fill="url(#paint0_radial_25255_47460)"/>
<path d="M9.46491 4.25793L5.8733 6.59034C4.48036 7.49493 2.31464 9.88324 3.29398 11.3913L3.42701 11.5961C3.27169 11.382 3.16848 11.1345 3.12559 10.8735C3.0827 10.6124 3.10131 10.345 3.17994 10.0924C3.3753 9.08627 4.2485 8.10316 5.46391 7.31386L10.2904 4.17948C11.5058 3.39018 12.7591 2.99233 13.7597 3.22182C14.0224 3.25273 14.2743 3.34452 14.4953 3.48988C14.7164 3.63524 14.9004 3.83017 15.0329 4.05916L14.9062 3.86407C13.9206 2.34627 10.8559 3.35461 9.46491 4.25793Z" fill="url(#paint1_linear_25255_47460)"/>
<path d="M14.5474 4.55773C14.5181 4.56951 14.4855 4.57045 14.4556 4.56039C14.4257 4.55033 14.4004 4.52993 14.3841 4.50285C14.2397 4.28715 14.02 4.13311 13.768 4.07088C13.7368 4.0638 13.7091 4.04607 13.6897 4.02075C13.6702 3.99542 13.6601 3.9641 13.6613 3.93217C13.6654 3.91522 13.673 3.89934 13.6837 3.88558C13.6944 3.87181 13.7079 3.86046 13.7233 3.8523C13.7387 3.84413 13.7557 3.83932 13.7731 3.83819C13.7905 3.83706 13.8079 3.83963 13.8243 3.84574C14.1344 3.92302 14.4042 4.11423 14.5798 4.38133C14.5909 4.39478 14.599 4.41043 14.6036 4.42725C14.6082 4.44407 14.6092 4.46167 14.6065 4.4789C14.6038 4.49612 14.5974 4.51257 14.5879 4.52717C14.5784 4.54177 14.5658 4.55418 14.5512 4.56358L14.5474 4.55773Z" fill="#FF9500"/>
<path d="M4.08309 11.3532C4.10557 11.331 4.11966 11.3016 4.12298 11.2701C4.1263 11.2387 4.11864 11.207 4.1013 11.1806C3.96134 10.962 3.90919 10.6986 3.95533 10.4432C3.96153 10.4119 3.9566 10.3794 3.94139 10.3513C3.92618 10.3232 3.90165 10.3013 3.87201 10.2893C3.85486 10.2862 3.83724 10.2867 3.82032 10.2909C3.80339 10.2951 3.78754 10.3028 3.77381 10.3135C3.76008 10.3243 3.74879 10.3378 3.74068 10.3533C3.73257 10.3687 3.72782 10.3857 3.72676 10.4031C3.6712 10.7179 3.73617 11.0421 3.90874 11.3111C3.91652 11.3267 3.92752 11.3405 3.94102 11.3516C3.95451 11.3626 3.9702 11.3707 3.98703 11.3752C4.00387 11.3797 4.02147 11.3806 4.03869 11.3779C4.0559 11.3751 4.07233 11.3687 4.08689 11.3591L4.08309 11.3532Z" fill="#FF9500"/>
<path d="M11.7377 3.84417C11.7377 3.84417 11.6122 3.8175 11.7353 3.72091C11.9549 3.56863 12.2071 3.46981 12.4717 3.43233C12.7363 3.39485 13.006 3.41975 13.2593 3.50505C13.9579 3.78639 13.6969 3.9781 13.6969 3.9781L11.7377 3.84417Z" fill="url(#paint2_linear_25255_47460)"/>
<path d="M4.58004 8.49281C4.58004 8.49281 4.60671 8.36732 4.4684 8.44049C4.23996 8.5792 4.04711 8.76938 3.90525 8.99587C3.76338 9.22236 3.67643 9.47888 3.65134 9.74495C3.6242 10.4976 3.90552 10.3371 3.90552 10.3371L4.58004 8.49281Z" fill="url(#paint3_linear_25255_47460)"/>
<path d="M4.63863 13.4827C4.24788 12.9793 3.92808 10.9791 3.92808 10.9791C3.43634 9.21824 4.87412 8.12644 5.66034 7.61586L10.4869 4.48148C11.2672 3.97471 12.8553 3.1015 14.2659 4.26568C14.2659 4.26568 15.9584 5.38551 16.264 5.93311C16.5697 6.48071 17.2027 8.35235 17.2027 8.35235L6.81228 14.989C6.81228 14.989 5.04399 14.0044 4.63863 13.4827Z" fill="url(#paint4_radial_25255_47460)"/>
<path d="M13.8496 7.45965C13.5781 9.37783 8.87838 12.4299 7.02146 11.8939C6.12634 11.6431 6.02858 7.54611 6.02858 7.54611L10.2913 4.77787C10.2913 4.77787 13.9827 6.53279 13.8496 7.45965Z" fill="url(#paint5_linear_25255_47460)"/>
<g style="mix-blend-mode:multiply">
<rect x="10.9893" y="4.62207" width="2.28896" height="4.18713" transform="rotate(-33 10.9893 4.62207)" fill="url(#pattern0_25255_47460)"/>
</g>
<g style="mix-blend-mode:multiply">
<rect x="3.68457" y="9.36523" width="2.28896" height="4.18713" transform="rotate(-33 3.68457 9.36523)" fill="url(#pattern1_25255_47460)"/>
</g>
<path d="M9.99182 20.4491L20.433 13.6685C20.433 13.6685 20.7132 12.904 20.584 12.705C19.7428 11.4096 19.0232 10.3015 18.5265 9.53678C18.1731 9.05359 17.722 8.65006 17.2026 8.35235C17.2026 8.35235 15.7319 8.31721 11.3941 11.162C8.45889 13.0487 7.10342 14.5919 6.57015 15.3681C6.31733 15.7348 6.65171 16.4717 7.01025 17.0239C7.63485 17.9856 8.54577 19.3883 9.06774 20.1921C9.3527 20.6395 9.99182 20.4491 9.99182 20.4491Z" fill="url(#paint6_radial_25255_47460)"/>
<path d="M10.5251 20.1033C9.7085 19.4075 9.00485 18.5891 8.43936 17.6774C7.9112 16.7978 7.47528 15.8661 7.13855 14.897C7.39487 14.5613 9.30427 12.7222 11.4873 11.3045C13.6704 9.88685 16.1068 8.85933 16.5159 8.75457C17.2787 9.46284 17.9612 10.2531 18.5509 11.1109C19.6797 12.8491 19.9187 14.0031 19.9187 14.0031L10.5251 20.1033Z" fill="url(#paint7_linear_25255_47460)"/>
<path d="M16.0472 6.6372C16.0472 6.6372 16.7538 6.36698 17.0902 6.88075C17.4266 7.39452 17.431 8.8534 17.0034 8.19077C16.5759 7.52815 16.1115 6.87283 16.0472 6.6372Z" fill="url(#paint8_linear_25255_47460)"/>
<path d="M18.9311 6.37553C18.6792 6.28669 17.1783 6.72606 17.1783 6.72606C16.8799 6.80893 16.9341 7.07605 17.0214 7.27454L19.1642 6.63191C19.1481 6.57389 19.1187 6.52046 19.0782 6.47592C19.0377 6.43139 18.9873 6.397 18.9311 6.37553Z" fill="url(#paint9_linear_25255_47460)"/>
<path d="M17.0217 7.27486C17.0572 7.35542 17.0999 7.4326 17.1493 7.50545L19.1937 6.77969C19.1891 6.72966 19.1793 6.68023 19.1645 6.63223L17.0217 7.27486Z" fill="url(#paint10_linear_25255_47460)"/>
<path d="M5.36843 13.5722C5.36843 13.5722 4.8342 14.1078 5.16993 14.6247C5.50567 15.1417 6.83343 15.7384 6.40199 15.0783C5.97055 14.4182 5.55755 13.7268 5.36843 13.5722Z" fill="url(#paint11_linear_25255_47460)"/>
<path d="M3.95682 16.1008C3.97809 15.8346 4.98995 14.6422 4.98995 14.6422C5.18704 14.4032 5.41098 14.5601 5.55485 14.7219L4.09623 16.418C4.04975 16.3798 4.01292 16.3311 3.9887 16.276C3.96448 16.2209 3.95356 16.1609 3.95682 16.1008Z" fill="url(#paint12_linear_25255_47460)"/>
<path d="M5.55459 14.7217C5.61375 14.7869 5.66689 14.8573 5.71336 14.9321L4.21882 16.5045C4.17496 16.48 4.13379 16.4509 4.09598 16.4179L5.55459 14.7217Z" fill="url(#paint13_linear_25255_47460)"/>
<path d="M10.2798 4.77699L6.01708 7.54523L6.17841 7.22134L9.91829 4.79264L10.2798 4.77699Z" fill="url(#paint14_linear_25255_47460)"/>
<path d="M20.0543 13.0496L20.2289 12.1568C20.2112 12.1295 20.1934 12.1022 20.177 12.0769C19.5118 11.0526 18.9417 10.1747 18.5299 9.54068C18.5299 9.54068 18.3402 9.22289 18.0785 8.77712L17.8472 9.65957C18.7388 10.6801 19.4818 11.8213 20.0543 13.0496Z" fill="url(#paint15_linear_25255_47460)"/>
<path style="mix-blend-mode:screen" d="M20.228 12.1568C19.5819 11.1618 19.2145 10.5961 18.8597 10.0498C18.7857 10.2477 18.7129 10.4558 18.6465 10.6654C19.193 11.4119 19.6631 12.2115 20.0495 13.0521L20.228 12.1568Z" fill="url(#paint16_linear_25255_47460)"/>
<path d="M9.59931 19.8392C8.70765 18.8167 7.96506 17.6732 7.39358 16.4427L6.53906 16.3569C6.81634 16.7455 7.00727 17.0181 7.00727 17.0181C7.50517 17.7848 8.18551 18.8324 8.70622 19.6343L9.59931 19.8392Z" fill="url(#paint17_linear_25255_47460)"/>
<path style="mix-blend-mode:screen" d="M8.70422 19.6407C8.05809 18.6457 7.69068 18.0799 7.33594 17.5337C7.54677 17.5466 7.76657 17.5647 7.985 17.5893C8.44468 18.3922 8.98399 19.1468 9.59478 19.8417L8.70422 19.6407Z" fill="url(#paint18_linear_25255_47460)"/>
<path d="M20.449 13.6585L9.99219 20.4492L10.2038 20.775L20.6606 13.9843L20.449 13.6585Z" fill="url(#paint19_linear_25255_47460)"/>
<path d="M14.6177 6.78358C12.6318 7.15822 10.7466 7.94503 9.08358 9.09324C9.03924 9.02496 8.99363 8.95473 8.94929 8.88645C10.6398 7.72169 12.5554 6.92365 14.5728 6.54366C14.588 6.62256 14.6025 6.70468 14.6177 6.78358Z" fill="black"/>
<path d="M10.9112 7.9233C10.9923 8.04816 10.5126 8.50113 9.84147 8.93695C9.17036 9.37278 8.5595 9.62802 8.47841 9.50316C8.39733 9.37831 8.87829 8.92729 9.55135 8.4902C10.2244 8.05311 10.8314 7.8004 10.9112 7.9233Z" fill="black"/>
<path d="M19.9839 11.8107C19.9983 11.8009 20.0107 11.7885 20.0203 11.7739C20.0299 11.7594 20.0366 11.7431 20.0399 11.726C20.0432 11.7089 20.0432 11.6914 20.0397 11.6743C20.0362 11.6572 20.0294 11.641 20.0197 11.6266L19.4115 10.6902C19.3928 10.6601 19.363 10.6387 19.3286 10.6304C19.2942 10.6221 19.2579 10.6277 19.2275 10.646L19.9839 11.8107Z" fill="#E3E3E3"/>
<path d="M8.47402 19.2856C8.45925 19.2948 8.44281 19.3011 8.42564 19.304C8.40846 19.3068 8.39088 19.3063 8.37391 19.3024C8.35695 19.2985 8.34091 19.2912 8.32674 19.2811C8.31256 19.271 8.30052 19.2582 8.29129 19.2434L7.68316 18.307C7.66336 18.2776 7.65588 18.2417 7.66233 18.2069C7.66878 18.1721 7.68866 18.1412 7.71767 18.1209L8.47402 19.2856Z" fill="#C9C9C9"/>
<path d="M11.4377 11.2283C9.75993 12.3178 6.93688 14.8557 6.93688 14.8557C6.93688 14.8557 5.30944 13.1056 5.02639 12.768L4.97571 12.6899L5.03532 12.6152C6.39539 10.9446 8.00811 9.49673 9.81513 8.324C11.4912 7.25884 13.2774 6.37784 15.1427 5.69633L15.2321 5.66321L15.2828 5.74125C15.9404 6.75376 16.5976 8.59022 16.5976 8.59022C16.5976 8.59022 13.1155 10.1387 11.4377 11.2283Z" fill="black"/>
<path d="M16.5513 8.4848C12.9376 9.83411 9.65903 11.95 6.94094 14.687C6.27705 13.9338 5.73583 13.442 5.12158 12.6927C7.73563 9.50839 10.8368 7.45009 15.1795 5.80871C15.8383 6.82318 16.6057 8.4661 16.5513 8.4848Z" fill="url(#paint20_linear_25255_47460)"/>
<path style="mix-blend-mode:screen" d="M8.4689 13.2981C10.3673 11.6835 12.4712 10.3275 14.7257 9.26537L13.5411 6.53153C10.9944 7.74627 8.61405 9.28277 6.4584 11.1034L8.4689 13.2981Z" fill="url(#paint21_linear_25255_47460)"/>
<path d="M22.0363 13.0909L8.82866 21.668C8.61317 21.8079 8.55192 22.0961 8.69186 22.3116L22.8093 44.0505C22.9492 44.2659 23.2373 44.3272 23.4528 44.1872L36.6604 35.6101C36.8759 35.4702 36.9372 35.1821 36.7972 34.9666L22.6798 13.2277C22.5399 13.0122 22.2517 12.9509 22.0363 13.0909Z" fill="url(#paint22_linear_25255_47460)"/>
<g style="mix-blend-mode:multiply">
<rect x="8.59668" y="21.9517" width="16.4694" height="26.6301" transform="rotate(-33 8.59668 21.9517)" fill="url(#pattern2_25255_47460)"/>
</g>
<path d="M22.0839 14.4467L10.0469 22.2637L23.4041 42.832L35.4412 35.0151L22.0839 14.4467Z" fill="url(#paint23_linear_25255_47460)"/>
<path style="mix-blend-mode:screen" d="M17.4624 24.2384C15.4065 21.585 12.6825 22.1613 10.6582 23.2041L23.4035 42.8302L30.019 38.534C28.4526 33.6489 24.8633 33.5334 22.202 32.3439C19.2557 31.0231 21.1799 29.0274 17.4624 24.2384Z" fill="url(#paint24_linear_25255_47460)"/>
</g>
<defs>
<pattern id="pattern0_25255_47460" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_25255_47460" transform="scale(0.0243902 0.0133333)"/>
</pattern>
<pattern id="pattern1_25255_47460" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image1_25255_47460" transform="scale(0.0243902 0.0133333)"/>
</pattern>
<pattern id="pattern2_25255_47460" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image2_25255_47460" transform="scale(0.00338983 0.00209644)"/>
</pattern>
<radialGradient id="paint0_radial_25255_47460" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.2175 9.34969) rotate(-33) scale(6.04575 6.04575)">
<stop stop-color="#870091"/>
<stop offset="1" stop-color="#600067"/>
</radialGradient>
<linearGradient id="paint1_linear_25255_47460" x1="2.64785" y1="10.3963" x2="14.2538" y2="2.85936" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#0C0D0D"/>
</linearGradient>
<linearGradient id="paint2_linear_25255_47460" x1="12.0089" y1="4.30877" x2="13.4389" y2="3.38011" gradientUnits="userSpaceOnUse">
<stop stop-color="#F7F7F7"/>
<stop offset="1" stop-color="#DBDBDB"/>
</linearGradient>
<linearGradient id="paint3_linear_25255_47460" x1="4.07283" y1="9.46291" x2="4.80637" y2="8.98655" gradientUnits="userSpaceOnUse">
<stop stop-color="#F7F7F7"/>
<stop offset="1" stop-color="#DBDBDB"/>
</linearGradient>
<radialGradient id="paint4_radial_25255_47460" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.19845 11.473) rotate(-33) scale(5.86431 4.45687)">
<stop stop-color="white"/>
<stop offset="1" stop-color="#870091"/>
</radialGradient>
<linearGradient id="paint5_linear_25255_47460" x1="5.49511" y1="7.64292" x2="10.831" y2="8.82082" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#870091"/>
</linearGradient>
<radialGradient id="paint6_radial_25255_47460" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.3072 14.1078) rotate(-33) scale(5.4549)">
<stop stop-color="white"/>
<stop offset="1" stop-color="#870091"/>
</radialGradient>
<linearGradient id="paint7_linear_25255_47460" x1="6.93631" y1="11.1175" x2="17.6465" y2="16.505" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="#870091"/>
</linearGradient>
<linearGradient id="paint8_linear_25255_47460" x1="16.0021" y1="6.70933" x2="18.9776" y2="8.4872" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint9_linear_25255_47460" x1="17.1755" y1="7.31315" x2="18.9934" y2="6.13257" gradientUnits="userSpaceOnUse">
<stop stop-color="#870091"/>
<stop offset="1" stop-color="#600067"/>
</linearGradient>
<linearGradient id="paint10_linear_25255_47460" x1="17.2151" y1="7.6069" x2="19.0451" y2="6.41852" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint11_linear_25255_47460" x1="5.33826" y1="13.4029" x2="5.75218" y2="16.8443" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint12_linear_25255_47460" x1="5.45728" y1="14.9239" x2="3.63936" y2="16.1045" gradientUnits="userSpaceOnUse">
<stop stop-color="#870091"/>
<stop offset="1" stop-color="#600067"/>
</linearGradient>
<linearGradient id="paint13_linear_25255_47460" x1="5.77924" y1="15.0335" x2="3.94929" y2="16.2219" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint14_linear_25255_47460" x1="5.96767" y1="7.46915" x2="10.2304" y2="4.70091" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#0C0D0D"/>
</linearGradient>
<linearGradient id="paint15_linear_25255_47460" x1="17.6566" y1="10.1051" x2="23.7085" y2="13.5557" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint16_linear_25255_47460" x1="18.5306" y1="11.0208" x2="22.5113" y2="13.2896" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B3B3B"/>
<stop offset="1"/>
</linearGradient>
<linearGradient id="paint17_linear_25255_47460" x1="6.47798" y1="17.1427" x2="13.3956" y2="21.085" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#1B1C1C"/>
</linearGradient>
<linearGradient id="paint18_linear_25255_47460" x1="6.7306" y1="18.562" x2="9.48718" y2="18.7578" gradientUnits="userSpaceOnUse">
<stop/>
<stop offset="1" stop-color="#3B3B3B"/>
</linearGradient>
<linearGradient id="paint19_linear_25255_47460" x1="10.0986" y1="20.6131" x2="20.5554" y2="13.8224" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#0C0D0D"/>
</linearGradient>
<linearGradient id="paint20_linear_25255_47460" x1="5.58655" y1="13.4086" x2="15.8054" y2="6.77246" gradientUnits="userSpaceOnUse">
<stop stop-color="#363B39"/>
<stop offset="1" stop-color="#0C0D0D"/>
</linearGradient>
<linearGradient id="paint21_linear_25255_47460" x1="7.18473" y1="12.2432" x2="14.2548" y2="7.65183" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B3B3B"/>
<stop offset="1"/>
</linearGradient>
<linearGradient id="paint22_linear_25255_47460" x1="15.7499" y1="33.18" x2="29.7398" y2="24.0949" gradientUnits="userSpaceOnUse">
<stop stop-color="#600067"/>
<stop offset="0.05" stop-color="#870091"/>
<stop offset="0.89" stop-color="#870091"/>
<stop offset="1" stop-color="#600067"/>
</linearGradient>
<linearGradient id="paint23_linear_25255_47460" x1="16.7249" y1="32.5469" x2="28.7639" y2="24.7286" gradientUnits="userSpaceOnUse">
<stop stop-color="#870091"/>
<stop offset="1" stop-color="#600067"/>
</linearGradient>
<linearGradient id="paint24_linear_25255_47460" x1="17.2201" y1="32.8942" x2="24.2668" y2="28.3181" gradientUnits="userSpaceOnUse">
<stop stop-color="#787878"/>
<stop offset="1"/>
</linearGradient>
<clipPath id="clip0_25255_47460">
<rect width="18" height="41.106" fill="white" transform="translate(0.120117 10.3262) rotate(-33)"/>
</clipPath>
<image id="image0_25255_47460" width="41" height="75" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAABLCAYAAADtXK6nAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD8klEQVRoQ82aW27qMBRFl/MkRXQWl/mPB6r2p2MoahP73A+0jZNCgRaCt4QIj4+lfR4+ie0+Pj4MoOs6R6aqdLHb7UzXuQE7M+Pt7c2en59p25YQAmZG0zRAHsDOLBrI+/u7NU1DCIHVakVRFKM/Pwp4BAmw3W6taRqWyyV1XQNQVdUIeG7Yb5AAr6+vVtc1ZsbT0xPDMLBcLnHOUZYlMC/oUUiAzWZjRVGwWCyik23bUlUVzjmc2zPOAXsSEvagzjnatqWua5xz1HVN0zQURTFbCvwIKW02G0sdLcsyVr/gpXvAXgQJB9CiKCJsURTUdR2/k24NejEkwMvLi5VlOXK0qqroZlmWMQVuCXoVJOxblJmxWCwipHMuwoYQbr4QXA0J+9BXVRVD3DQNZVmOHFWrgr/D/goSxo4qN82Mtm1j2J1zNwn/eN27Qv/+/XMAfd8TQuDr6wuAz89P+r7He4+ZIRPSAeZa/dpJabvdWlrlRVHQNE3MU7n5l5Xqz5Cwz9FpTqZtKv0M14P+Otyp1uu1CyHQ9z1mRgiBEALDMBBCAGAYBn5ryE0gYZ+j3vuYo957APQd8Ov8vEm4U22329jwtdZrRVLVq3VdGvabOSkp3ApvGn7vfbw2s4sdvTmk8lMR0rX3nmEYRt/BZaG/OSTsQZWL3vv4UnGlbl6iu0BKaYWnzqYvOO/m3SDX67VTmKduKuxalc7pbpAwBgVi8UxbVQjhRzfvCgmHQpo287TyzxXR3SGlaUuSg3AAPqVZINfrtYND0Sj8KqpzRTQLpDQMw8hRIMIpV49pNkgVkeBU4X3fx8Fk+lhHmg1SUrhTYE3xAp+GfFZIuSnpuu/7b2mQalZIKR3jpsvjsQKaHXLaN9PC0bu+k2aHlASS9kyBTkP+EEi5OXVMn9NnS/AgSGnq3HRSUl4+FPKYtAqlPfNhkBqMBTUd29JUeBiklIb6WA+FDCBVJM65CJpFdafSUpgqBYYHQ6YjnHJyGIbRSrTb7eyhkFLa2PWe9sosINPi0USUTbglNXXn3LdVCDKAVF6mymbAmErTOYzbEmQEmYZacFnl5DllBSk3p3eNWUGq7WRbOOmdow4DSNlApiuM9360p54FpG4n4JCX2a04sA+3nNOD/6Io6LrOZQUpUMHK3WwgpXTg1VZfNpCpg+k2NWQEeey2QcoGUhv52jUzs7hjlg2kbhn0Sk8eZAMJp0OeDaTOGnVdNyoayAhSu7mq8HQHNxtIOGyMTp+dZwOZ7ol/++3I/2fXZrOxEEIc0aab9VlAwmGoyNZJgOVyCRw/8jCu9QcpPfZ4TFk4qcPOpw6OZAHZdd2Pv2cBCbBarU4ev/kPUxRUYypjhqEAAAAASUVORK5CYII="/>
<image id="image1_25255_47460" width="41" height="75" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAABLCAYAAADtXK6nAAAACXBIWXMAAC4jAAAuIwF4pT92AAADsElEQVRoQ82aXU7rMBCFPztVr7wAVoDU/a+HJ3aAkBAJSWzfh3Jc56cphTTxkSKV0odPZ+bMOGlNjJFS9fLyEgEOtz64tT4/P+Pb2xtN0wBwOp2MKcHJuq5j27Z473l/fyfGSIyR5+dnAzs6Wdd1BGiahhACVVXx8fFBjJG+7zmdTkaf3RxScG3b0vc9Xdel133fAwwAYUPIuq5jCCGB1HUNnGHVfzAFhA0g67qO6rG+71HvwcVNmIeTHgqp0nZdRwiBr68vcje7rsN7vwgID4KUeyEEND2apkluCjrGeBMQHgCZByOEgPce7z0xxvSeyv8TQFgRUnAqpzEmQemSuyGEHwPCSpBKrjGGvu/x3tO2LUD623tPCAFYDsmc/gwpB+EchLysCkiuewHhj5ByEJiMlzUclH4NqQQLRiFZ00HpV5B5SCSByb01HJTuhlSJdSkkeYJz/RUQ7oTMU6yydl2X/t/3/WDUrAEId0COHYwxps0BZ8DfzsFb+hGkAK21ad+O+zHvwzUB4YeQWmNt22KMwXufnNPIWbvEuW5CatSME2utTXNx7OzaWoTM+1BSaefujR7hIoC99QFgMKiBlG54bJmlq5D5mVDSiNHg1n3JIwFhATIfJyGEwcAGHt6HuWYhx2FRgq21qfSPGjdzmg3OtTJriG+tiZN5L+YuAgl0SxdhwUlpXPIt0jzWwMm6rqOAxiWHy4zcWlfTrVGjlSjdc5e3lhJk/qQBLvt63Id7aOCkoHRO1GbJ4bd2ERZ2t4BjjBhz5trVSR0k5Jb3PoHBZf3tpUG5545dOfwepYYMUiD5br52JNtaE8ixlO69XIRvyLGL4x29t5t2/CxRAcmPZXsrOZmvwdxZ728/iX20EqQxZlL2UrR4jxNCGMzLvWTzAQ4XMPXm3qEBsMYYdGnThBDSrcLe/QhZua09v1TK9zg3XpMF0mMTSc6WIruU5FJArco8pxJCAzO7u8RZaXO3xuOohGTD9wiCS1iMMVRVVZaTelFimaVU7qqq0pu6CStFVuVVyq21WGuLSTZ8l3v8IKAkF+Eb0lpLVVUpOEuzcw8lmty9/AukEmSdcyYPTYxxEKISNKlr0eUGOB6PAOnnCaUoQR4Oh+RikSPIOWcEWHS5xw+oSgKdJSn2gOGcS1aWFBqYSXe+w0vRhESDXOOoBA0gtX2Ox+PgN417a+Lkv3//gLL6cgLpnDPOubJ7Es79aIzh9fW1iLUzC+mcM4fDzZ9nbKarNX16eiqmL/8Djm4noCsnbQwAAAAASUVORK5CYII="/>
<image id="image2_25255_47460" width="295" height="477" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>

`;
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function calculateBearing(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ): number {
    const toRadians = (deg: number): number => (deg * Math.PI) / 180;
    const toDegrees = (rad: number): number => (rad * 180) / Math.PI;

    const dLng = toRadians(lng2 - lng1);
    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
    const x =
      Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) -
      Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
    const bearing = toDegrees(Math.atan2(y, x));
    return (bearing + 40) % 360; // Normalize to 0-360 degrees
  }

  const handleMarkerClickForInfo = (customer: any) => {
    handleMarkerClick(customer);
  };

  function moveVehicle(
    marker: google.maps.Marker,
    startLatLng: google.maps.LatLng | { lat: number; lng: number },
    endLatLng: google.maps.LatLng | { lat: number; lng: number },
    duration: number
  ) {
    const frames = 60;
    const interval = duration / frames;
    let frame = 0;

    const start =
      startLatLng instanceof google.maps.LatLng
        ? startLatLng
        : new google.maps.LatLng(startLatLng.lat, startLatLng.lng);
    const end =
      endLatLng instanceof google.maps.LatLng
        ? endLatLng
        : new google.maps.LatLng(endLatLng.lat, endLatLng.lng);

    const interpolate = (
      start: number,
      end: number,
      fraction: number
    ): number => start + (end - start) * fraction;

    // Animation loop
    const animate = () => {
      frame++;
      const progress = frame / frames;

      const lat = interpolate(start.lat(), end.lat(), progress);
      const lng = interpolate(start.lng(), end.lng(), progress);
      const intermediatePosition = new google.maps.LatLng(lat, lng);

      marker.setPosition(intermediatePosition);
      if (frame < frames) {
        setTimeout(animate, interval);
      }
    };
    animate();
  }

  const snapToRoads = async (latLngs:any) => {
    const path = latLngs.map((point:any) => `${point.lat},${point.lng}`).join("|");
    const url = `https://roads.googleapis.com/v1/snapToRoads?path=${path}&interpolate=true&key=${process.env.REACT_APP_GOOGLE_MAP_KEY || ""}`;
  
    const response = await fetch(url);
    const data = await response.json();
  };

  const PlannedRoutePolyline: React.FC = () => {
    const map = useMap();
    useEffect(() => {
      if (!map) {
        console.warn("Map object not available yet.");
        return;
      }

      // planned route
      // planned route
      // planned route
      // planned route
      // planned route

      let decodedPath: any = "";
      let latLngPath: any = [startPoint];
      if (plannedData) {
        decodedPath = polyline?.decode(
          plannedData[0]?.polyline?.encodedPolyline
        );
        latLngPath = decodedPath?.map(([lat, lng]: any) => ({ lat, lng }));
      } else {
        // return;
      }

      const tolerance = 0.001;

      const isNear = (point: { lat: number; lng: number }) => {
        // Check against check-in coordinates if available, otherwise use planned coordinates
        const targetLat = routeForSelectedCustomer.check_in_latitude 
          ? Number(routeForSelectedCustomer.check_in_latitude)
          : Number(routeForSelectedCustomer.latitude);
        const targetLng = routeForSelectedCustomer.check_in_longitude 
          ? Number(routeForSelectedCustomer.check_in_longitude)
          : Number(routeForSelectedCustomer.longitude);
          
        return (
          Math.abs(point.lat - targetLat) <= tolerance &&
          Math.abs(point.lng - targetLng) <= tolerance
        );
      };
      
      if(routeForSelectedCustomer){
        // Determine which coordinates to zoom to
        let targetLat, targetLng;
        
        // Check if visit has check-in coordinates, if so use those, otherwise use planned coordinates
        if (routeForSelectedCustomer.check_in_latitude && routeForSelectedCustomer.check_in_longitude) {
          targetLat = Number(routeForSelectedCustomer.check_in_latitude);
          targetLng = Number(routeForSelectedCustomer.check_in_longitude);
        } else {
          targetLat = Number(routeForSelectedCustomer.latitude);
          targetLng = Number(routeForSelectedCustomer.longitude);
        }
        
        // Adjust zoom level based on environment
        const zoomLevel = process.env.REACT_APP_ENV === "production" ? 18 : 15;
        
        map.setZoom(zoomLevel);
        map.setCenter({lat: targetLat, lng: targetLng});
      }

      const index = latLngPath.findIndex(isNear);

      const filteredPath =
        index !== -1 ? latLngPath.slice(0, index + 1) : latLngPath;

      const googlePolyline = new google.maps.Polyline({
        path: filteredPath,
        geodesic: true,
        strokeColor: "#00A39E",
        strokeOpacity: 1.0,
        strokeWeight: 4,
        // zIndex: 2
      });

      const customIcon = {
        url:
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(`<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8.5" r="6.5" fill="#00E5DE" stroke="#870091" stroke-width="3"/>
              </svg>
             `),

        scaledSize: new google.maps.Size(24, 24),
        anchor: new google.maps.Point(12, 12),
      };

      const firstLatLng = latLngPath[0];

      // Create start and end day markers based on schedule API data
      let startDayMarker: any = null;
      let endDayMarker: any = null;
      let origin: any = null;
      
      // Use begin coordinates from schedule API if available, otherwise use first point from route
      if (employeeSchedule?.begin_latitude && employeeSchedule?.begin_longitude) {
        const startMarkerUrl =
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
          <path d="M16 0C8 0 2 6 2 14c0 10.8 14 24 14 24s14-13.2 14-24c0-8-6-14-14-14z" fill="rgb(138, 0, 148)"/>
          <circle cx="16" cy="14" r="8" fill="rgba(138, 0, 148, 0.5)"/>
          <text x="16" y="18" font-size="12" text-anchor="middle" fill="#ffffff" font-family="Arial, sans-serif" font-weight="bold">S</text>
        </svg>`);
        
        startDayMarker = new google.maps.Marker({
          position: {
            lat: Number(employeeSchedule.begin_latitude),
            lng: Number(employeeSchedule.begin_longitude),
          },
          map: map,
          icon: startMarkerUrl,
        });
      } else {
        origin = new google.maps.Marker({
          position: firstLatLng,
          map: map,
          icon: customIcon,
        });
      }
      
      // Use end coordinates from schedule API if available
      if (employeeSchedule?.end_latitude && employeeSchedule?.end_longitude) {
        const EndMarkerUrl =
          "data:image/svg+xml;charset=UTF-8," +
          encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
          <path d="M16 0C8 0 2 6 2 14c0 10.8 14 24 14 24s14-13.2 14-24c0-8-6-14-14-14z" fill="rgb(138, 0, 148)"/>
          <circle cx="16" cy="14" r="8" fill="rgba(138, 0, 148, 0.5)"/>
          <text x="16" y="18" font-size="12" text-anchor="middle" fill="#ffffff" font-family="Arial, sans-serif" font-weight="bold">E</text>
        </svg>`);
        
        endDayMarker = new google.maps.Marker({
          position: {
            lat: Number(employeeSchedule.end_latitude),
            lng: Number(employeeSchedule.end_longitude),
          },
          map: map,
          icon: EndMarkerUrl,
        });
      }

      let destination: any;
      // const lastLatLng = actualData[latLngPath?.length - 1];
      // if (filteredPath?.length === latLngPath?.length) {
      //   destination = new google.maps.Marker({
      //     position: lastLatLng,
      //     map: map,
      //     icon: customIcon,
      //   });
      // }

      // actual route
      // actual route
      // actual route
      // actual route

      let updatedLocation = actualData;
      if (vehicleLocation?.lat) {
        updatedLocation?.push(vehicleLocation);
      }

      const prevLatLng = updatedLocation[updatedLocation?.length - 5];
      const currLatLng = updatedLocation[updatedLocation?.length - 1];

      const bearing = calculateBearing(
        prevLatLng?.lat,
        prevLatLng?.lng,
        currLatLng?.lat,
        currLatLng?.lng
      );
      // snapToRoads(updatedLocation)
      const googleActualPolyline = new google.maps.Polyline({
        path: updatedLocation,
        geodesic: false,
        strokeColor: "#870091",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      });

      const vehicleIcon = {
        url: getRotatedSvg(bearing),
        scaledSize: new google.maps.Size(48, 48),
        anchor: new google.maps.Point(16, 16),
      };

      const getColor = (status: string): any => {
        switch (status) {
          case "SUCCESSFUL":
            return "#00C48C";
          case "PRODUCTIVE":
            return "#FFAA2A";
          case "FAILED":
            return "#FF4D68";
          default:
            return "black";
        }
      };

      const createCustomIcon = (status: string) => {
        const fillColor = getColor(status);
        const isGreen = fillColor === "#00C48C";
        return {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 14,
          fillColor: fillColor,
          fillOpacity: 1,
          strokeWeight: 2,
          strokeColor: isGreen ? "#000000" : "#ddd",
          labelOrigin: new google.maps.Point(0, 0),
        };
      };

      const breakCustomIcon = () => ({
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: getColor("FAILED"),
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: "#ddd",
        labelOrigin: new google.maps.Point(0, 0),
      });

      const customerLocationMarkers = employeeSchedule?.customer_visits?.map(
        (coords: any, index: number) => {
          return new google.maps.Marker({
            position: {
              lat: Number(coords.latitude),
              lng: Number(coords.longitude),
            },
            map: map,
            icon: createCustomIcon(coords.outcome_status),
            label: {
              text: coords.sequence.toString(),
              color: "#FFFFFF",
              fontSize: "16px",
            },
          });
        }
      );

      const checkInMarkers = employeeSchedule?.customer_visits
        ?.filter(
          (coords: any) =>
            coords?.check_in_latitude && coords?.check_in_longitude
        )
        ?.map((coords: any) => {
          return new google.maps.Marker({
            position: {
              lat: Number(coords.check_in_latitude),
              lng: Number(coords.check_in_longitude),
            },
            map: map,
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 14,
              fillColor: getColor(coords.outcome_status),
              fillOpacity: 1,
              strokeWeight: 3,
              strokeColor: "purple",
              labelOrigin: new google.maps.Point(0, 0),
            },
            label: {
              text: coords.sequence.toString(),
              color: "#FFFFFF",
              fontSize: "16px",
            },
          });
        });

      let stopMarker: any = [];
      let destinationVehicle: any;

      if (selectedRoute === "actual" || selectedRoute === "break") {
        const lastLatLngForActual =
          updatedLocation[updatedLocation?.length - 1];
        destinationVehicle = new google.maps.Marker({
          position: lastLatLngForActual,
          map: map,
          icon: vehicleIcon,
        });
        const startLatLng = updatedLocation[updatedLocation?.length - 3];
        if(startLatLng && vehicleLocation?.lat){
          moveVehicle(destinationVehicle, startLatLng, lastLatLngForActual, 2000);
        }
        if (locationPoint) {
          map.setCenter(lastLatLngForActual);
          map.setZoom(15);
        }

        googleActualPolyline.setMap(map);

        if (selectedRoute === "break") {
          let count = 1;
          stopMarker = employeeSchedule?.customer_visits?.map(
            // eslint-disable-next-line array-callback-return
            (coords: any, index: number) => {
              if (coords.is_break_taken) {
                new google.maps.Marker({
                  position: {
                    lat: Number(coords.latitude),
                    lng: Number(coords.longitude),
                  },
                  map: map,
                  icon: breakCustomIcon(),
                  label: {
                    text: count.toString(),
                    color: "#FFFFFF",
                    fontSize: "10px",
                  },
                });
                count++;
              }
            }
          );
        }
      } else {
        if (locationPoint) {
          map.setCenter({ lat: latLngPath[0].lat, lng: latLngPath[0].lng });
          map.setZoom(11);
        }
      }

      googlePolyline.setMap(map);

      return () => {
        origin?.setMap(null);
        startDayMarker?.setMap(null);
        endDayMarker?.setMap(null);
        destinationVehicle?.setMap(null);
        stopMarker?.forEach((marker: any) => marker?.setMap(null));
        destination?.setMap(null);
        googleActualPolyline?.setMap(null);
        googlePolyline?.setMap(null);
        customerLocationMarkers?.forEach((marker: any) => marker.setMap(null));
        checkInMarkers?.forEach((marker: any) => marker.setMap(null));
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      map,
      showDirections,
      routeForSelectedCustomer,
      vehicleLocation,
      actualData,
    ]);

    return null;
  };
  

  const AllEmployeemarker: React.FC = () => {
    const map = useMap();

    useEffect(() => {
      const customerLocationMarkers = markersData?.map(
        (marker: any, index: number) => {
          const newMarker = new google.maps.Marker({
            position: marker?.location,
            map: map,
            icon: {
              path: "M12 2a10 10 0 1 1 0 20a10 10 0 0 1 0-20z",
              fillColor: getFillColor(marker.status),
              fillOpacity: 1,
              scale: 1,
              strokeColor: "white",
              strokeWeight: 2,
            },
            clickable: true,
          });

          google.maps.event.addListener(newMarker, "click", () => {
            handleMarkerClick(marker);
          });

          return newMarker;
        }
      );

      return () => {
        customerLocationMarkers?.forEach((marker: any) => marker.setMap(null));
      };
    }, [map]);

    return null;
  };

  const AllEmployeeMarkerTwoLocations: React.FC = () => {
    const map = useMap();

    useEffect(() => {
      const location1 = customerLoaction.position;
      const location2 = storeLoaction.position;

      const marker1 = new google.maps.Marker({
        position: location1,
        map: map,
        icon: {
          path: "M12 2a10 10 0 1 1 0 20a10 10 0 0 1 0-20z",
          fillColor: getFillColor("enroute"),
          fillOpacity: 1,
          scale: 1,
          strokeColor: "white",
          strokeWeight: 2,
        },
        clickable: true,
      });

      const marker2 = new google.maps.Marker({
        position: location2,
        map: map,
        icon: {
          path: "M12 2C8.13 2 5 5.13 5 9c0 3.59 3.4 8.34 6.32 11.52c.38.43.99.43 1.36 0C15.6 17.34 19 12.59 19 9c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5z",
          fillColor: "black",
          fillOpacity: 1,
          scale: 2,
          strokeColor: "white",
          strokeWeight: 1,
        },
        clickable: true,
      });

      google.maps.event.addListener(marker1, "click", () => {
        handleMarkerClickForInfo(customerLoaction);
      });
  
      // google.maps.event.addListener(marker2, "click", () => {
      //   handleMarkerClick(location2);
      // });

      const center = location1 ? location1 : location2;
      if(center?.lat){
        map?.setCenter(center);
        map?.setZoom(11)
      }

      return () => {
        marker1.setMap(null);
        marker2.setMap(null);
      };
    }, [map]);

    return null;
  };

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY || ""}>
      <Map
        style={{ width: "100%", height: "100%" }}
        defaultCenter={saudiCenter}
        defaultZoom={0}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        minZoom={5}
        maxZoom={20}
        zoomControl={true}
        restriction={{
          latLngBounds: saudiBounds,
          strictBounds: true,
        }}
      >
        {selectedMarker && (
          <InfoWindow
            position={selectedMarker?.location}
            onCloseClick={handleCloseInfoWindow}
            className="hidden md:block"
          >
            <div className="pt-2">
              {showNotificationInfo && <p>Name : {markarData?.name_eng}</p>}
              <p>
                {t("visit.total_travel")}:{markarData?.total_traveling_till_now}{" "}
                {t("visit.km")}
              </p>
              <p>
                {t("visit.total_visit")} : {markarData?.total_visits}
              </p>
              <p>
                {t("visit.successful_visit")} : {markarData?.successful_visits}
              </p>
              <p>
                {t("visit.failed_visit")}: {markarData?.failed_visits}{" "}
              </p>
              <p>
                {t("visit.collection_visit")}: {markarData?.productive_visits}
              </p>
            </div>
          </InfoWindow>
        )}

        {showMarkers && <AllEmployeemarker />}
        {actualDataLoader && <div className="absolute top-[50%] left-[50%]" ><Loader /></div>}
        {showDirections && selectedRoute && <PlannedRoutePolyline />}

        {showDirections && (
          <>
            <div className="p-2 pl-4 absolute bottom-[20px] left-[2%] z-index-[9999] bg-white w-[300px]  flex items-center gap-3">
              <div className="flex gap-2 items-center">
                <div className="bg-[#00A39E] w-[10px] h-[10px] rounded-full"></div>
                {t("visit.planned_route")}
              </div>
              <div className="flex gap-2 items-center">
                <div className="bg-purple w-[10px] h-[10px] rounded-full"></div>
                {t("visit.actual_route")}
              </div>
            </div>
          </>
        )}
        {(showMarkers || showNotificationInfo) && (
          <>
            <div className="p-2 pl-4 absolute bottom-[20px] left-[2%] z-index-[9999] bg-white w-auto  flex items-center gap-3">
              {showNotificationInfo ? (
                <>
                  <div className="flex gap-2 items-center">
                    <div className="bg-black w-[10px] h-[10px] rounded-full"></div>
                    {t("visit.store_location")}
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className="bg-purple w-[10px] h-[10px] rounded-full"></div>
                    {t("visit.user_location")}
                  </div>
                </>
              ) : (
                <>
                  <div className="flex gap-2 items-center">
                    <div className="bg-purple w-[10px] h-[10px] rounded-full"></div>
                    {t("visit.enroute")}
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className="bg-cugreen w-[10px] h-[10px] rounded-full"></div>
                    {t("visit.at_location")}
                  </div>
                  <div className="flex gap-2 items-center">
                    <div className="bg-customorange w-[10px] h-[10px] rounded-full"></div>
                    {t("visit.idle")}
                  </div>
                </>
              )}
            </div>
          </>
        )}

        {showDirections && (
          <div className="absolute top-5 left-5 bg-opacity-90 bg-white p-4  flex flex-col gap-3">
            <div className="text-13 font-semibold">
              {t("visit.compare_route")}
             
              <div>
                <label className="text-13 font-semibold">
                  {" "}
                  <input
                    name="route"
                    checked={selectedRoute === "actual"}
                    onChange={handleRouteChange}
                    value="actual"
                    type="radio"
                  />{" "}
                  {t("visit.actual_route")}
                </label>
              </div>
              <div className="py-1">
                <label className="text-13 font-semibold">
                  <input
                    name="route"
                    checked={selectedRoute === "planned"}
                    onChange={handleRouteChange}
                    value="planned"
                    type="radio"
                  />{" "}
                  {t("visit.planned_route")}
                </label>
              </div>
            </div>
            <div className="text-13 font-semibold">
              {t("visit.break")}
              <div className="pt-1">
                <label>
                  {" "}
                  <input
                    name="route"
                    checked={selectedRoute === "break"}
                    onChange={handleRouteChange}
                    value="break"
                    type="radio"
                  />{" "}
                  {t("visit.stops")}
                </label>
              </div>
            </div>
          </div>
        )}

        {showNotificationInfo && (
          <AllEmployeeMarkerTwoLocations/>
        )}
      </Map>
    </APIProvider>
  );
};

export default GoogleMap;
